// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"_223QRf28h2rT","item":"_1irKZZ_W54Mp","icon":"_3mjXSkycljpj"};